module.exports = __webpack_public_path__ + "static/media/profile-picture.d1f52fc6.png";